export default __webpack_public_path__ + "static/media/randstad.4bbfc5d8.svg";